export const SINGLE = 'single';
export const BUNDLE = 'bundle';
export const PREPACK = 'prepack';
export const CONTENT_OFFERING_TYPE_LIST = [SINGLE, BUNDLE, PREPACK];



// WEBPACK FOOTER //
// ./app/constants/checkoutCollectionTypes.js